// cihk9.godislovestore.com
// cihk9.johnc3v16.com

import { useNavigate } from 'react-router-dom';
// const navigate = useNavigate();

export const VERSION = 'v1.r2026.0715.2259';

export const API_BASE_URL = 'https://restfulcihk9.johnc3v16.com/';
export const API_BASE_URL1 = 'http://localhost:12345/';
export const API_BASE_URL3 = '';
export const API_BASE_URL4 = 'https://v2restfulbn.godislovestore.com/';
export const DEBUG = false;
export const DISPLAY_MODES = [
    { name: '簡化', value: 1 },
    { name: '詳細', value: 2 }
];
export const SORT_OPTIONS = [
    { label: 'A', value: 'A' },
    { label: 'B', value: 'B' },
    { label: 'C', value: 'C' },
    { label: 'D', value: 'D' },
    { label: 'E', value: 'E' },
    { label: 'F', value: 'F' },
    { label: 'G', value: 'G' },
    { label: 'H', value: 'H' },
    { label: 'I', value: 'I' },
    { label: 'J', value: 'J' },
    { label: 'K', value: 'K' },
    { label: 'L', value: 'L' },
    { label: 'M', value: 'M' },
    { label: 'N', value: 'N' },
    { label: 'O', value: 'O' },
    { label: 'P', value: 'P' },
    { label: 'Q', value: 'Q' },
    { label: 'R', value: 'R' },
    { label: 'S', value: 'S' },
    { label: 'T', value: 'T' },
    { label: 'U', value: 'U' },
    { label: 'V', value: 'V' },
    { label: 'W', value: 'W' },
    { label: 'X', value: 'X' },
    { label: 'Y', value: 'Y' },
    { label: 'Z', value: 'Z' },
];